import { useConfig } from "../api/hooks";
import { openTelegramLink } from "./telegram";

/**
 * «Получить консультацию», «Задать вопрос», «Поддержка» — одна и та же
 * ссылка. Берётся из /config (SUPPORT_URL на сервере); если её нет —
 * открывается чат с самим ботом: там менеджер видит сообщение как обычный
 * диалог. Ссылка не запекается в бандл: сменить чат поддержки можно без
 * пересборки фронта.
 */
export function useSupport(): { available: boolean; open: () => void } {
  const config = useConfig();
  const url =
    config.data?.supportUrl ??
    (config.data?.botUsername ? `https://t.me/${config.data.botUsername}` : null);

  return {
    available: url !== null,
    open: () => {
      if (url) openTelegramLink(url);
    },
  };
}
